import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import stitches from "../theme.config.es.js";
import EzTextInput from "./EzTextInput.es.js";
const rows = (size) => {
  switch (size) {
    case "small":
      return 2;
    case "large":
      return 10;
    case "medium":
    default:
      return 5;
  }
};
const textArea = stitches.css({
  resize: "vertical",
  "&&": {
    lineHeight: "1.5rem",
    padding: "$100 $150"
  }
});
const EzTextArea = forwardRef(function EzTextArea2({ size, ...rest }, ref) {
  return /* @__PURE__ */ jsx(EzTextInput, { ref, ...rest, multiLine: true, rows: rows(size), className: textArea() });
});
export {
  EzTextArea as default
};
//# sourceMappingURL=EzTextArea.es.js.map
